import { ReactNode } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

interface MainLayoutProps {
  children: ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <div className="min-h-screen min-h-[100dvh] bg-background relative overflow-x-hidden">
      <Header />
      <main className="pt-16 sm:pt-18 md:pt-20 relative z-10">{children}</main>
      <Footer />
    </div>
  );
};
